import {
  UsersService,
  type AppUserDetail,
  type UsersFilters,
  type UsersResponse,
} from "@/lib/api/users.service";
import { useQuery } from "@tanstack/react-query";

export const useUsers = (filters?: UsersFilters) => {
  return useQuery<UsersResponse>({
    queryKey: ["/admin/users", filters],
    queryFn: () => UsersService.getUsers(filters),
  });
};

export const useUser = (userId: string | undefined) => {
  return useQuery<AppUserDetail>({
    queryKey: ["/admin/users", userId],
    queryFn: () => UsersService.getUserById(userId as string),
    enabled: !!userId,
  });
};
